
import { Fab } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import CleanupIcon from "@material-ui/icons/ClearAll";
import { useState } from "react";
import ShapesCleanupDialog from "./ShapesCleanupDialog";

interface Props {
  buttonClasses: ClassNameMap;
  readonly customerId: number;
  readonly priceListId: number;
  reportAlerts: (messages: string[]) => void;
  refreshShapes: () => void,
}

const ShapesCleanupButton = (props: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleCleanupButtonClicked = () => {
    setDialogOpen(true);
  };

  const handleCleanupConfirmed = (messages: string[]) => {
    props.reportAlerts(messages);
    setDialogOpen(false);
    props.refreshShapes();
  };

  return <>
    <Fab
      aria-label="cleanup"
      className={ props.buttonClasses.button }
      color="primary"
      size="medium"
      onClick={ handleCleanupButtonClicked }
    >
      <CleanupIcon style={ { backgroundColor: 'red', borderRadius: 50, height: 50, width: 50 } } />
    </Fab>
    <ShapesCleanupDialog
      customerId={ props.customerId }
      priceListId={ props.priceListId }
      open={ dialogOpen }
      onCleanupConfirmed={ handleCleanupConfirmed }
      onCleanupCanceled={ () => setDialogOpen(false) }
    />
  </>;
}

export default ShapesCleanupButton;